import {
  getRouteConfigForVariant,
  navigateToNextOnboardingPage,
} from '@app-studio-web/ui/helpers/abTestRouting'
import { trackOnboardingFormData } from '@app-studio-web/ui/helpers/snowplowTracking'
import { alzheimerRouteConfig } from '@config/abTestConfig'

export default async function navigateToNextAlzheimerPageAction({
  request,
}: {
  request: Request
}) {
  const url = new URL(request.url)
  if (url.searchParams.get('mode') === 'update') {
    return null
  }

  const formData = await request.formData()

  trackOnboardingFormData({
    formData,
    url: request.url,
    orderedRoutes: getRouteConfigForVariant('baseline', alzheimerRouteConfig),
  })

  return navigateToNextOnboardingPage({
    request,
    routeConfig: alzheimerRouteConfig,
    variant: 'baseline',
    redirectOnComplete: '/sign-up/company',
  })
}
